import { useMemo, useState } from "react";
import { Disclosure } from "../../components/Disclosure";
import { FiltroArticulos } from "./components/FiltroArticulos";
import { IndicadoresCantidades } from "./components/IndicadoresCantidades";
import { TablaArticulos } from "./components/TablaArticulos";
import { Breadcrumb } from "../../components/Breadcrumb";
import { useArticulosStock, type TiposSeleccionFiltroStock } from "../../hooks/Api/Articulos";

export function GestionArticulosPage() {
	const [filtroStock, setFiltroStock] = useState<TiposSeleccionFiltroStock>("todo");
	const [filtroFamilia, setFiltroFamilia] = useState<string[]>([]);
	const [filtroTipoArticulo, setFiltroTipoArticulo] = useState<string[]>([]);

	const { data: articulos, error: errorArticulos, isPending: articulosPending } = useArticulosStock({
		idsFamilia: filtroFamilia,
		tipo: "todo",
	});

	const filteredData = useMemo(() => {
		if (!articulos) return articulos;
		let filtered = articulos;
		if (filtroTipoArticulo.length != 0)
			filtered = articulos.filter(art => filtroTipoArticulo.includes(String(art.tipoArticulo)));

		if (filtroStock === "enStock") filtered = filtered.filter(art => art.stock != null && art.stock > 0);
		else if (filtroStock === "minimo") filtered = filtered.filter(art => art.stock != null && art.stock < (art.min ?? 0));
		else if (filtroStock === "maximo") filtered = filtered.filter(art => art.stock != null && art.stock > (art.max ?? Infinity));
		else if (filtroStock === "roturaStock") filtered = filtered.filter(art => art.stock != null && art.stock <= 0);

		return filtered;
	}, [articulos, filtroTipoArticulo, filtroStock]);

	const counts = useMemo(() => {
		if (!articulos) return { bajoMinimo: "", sobreMaximo: "", roturaStock: "", ofCount: "" };

		const count = { bajoMinimo: 0, sobreMaximo: 0, roturaStock: 0, ofCount: 0 };
		articulos.forEach(art => {
			if (art.stock == null) return;

			if (art.min != null && art.stock < art.min) count.bajoMinimo++;
			if (art.max != null && art.stock > art.max) count.sobreMaximo++;
			if (art.stock <= 0) count.roturaStock++;
		});


		return count;
	}, [articulos]);


	return (
		<div id="content" className="content" >
			<title>Almacen | Gestión de Artículos</title>

			<Breadcrumb
				sectionTitle="Gestión de Artículos"
				links={[
					{ label: "Gestión de Artículos", active: true }
				]}
			/>

			<div className="box-shadow panel-box panel-info" style={{ display: "none" }}>
				<h4><strong>Info</strong></h4>
				Aquí podras encontrar un listado con información sobre la producción de ordenes de fabricación. Desde el botón + podras añadir una orden a la serie.
			</div>


			<Disclosure style={{ marginBottom: 20 }}>
				{/* First element is the summary, second is the content */}
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<FiltroArticulos
					filtroStock={filtroStock}
					setFiltroStock={setFiltroStock}

					familia={filtroFamilia}
					setFamilia={setFiltroFamilia}

					tipoArticulo={filtroTipoArticulo}
					setTipoArticulo={setFiltroTipoArticulo}
				/>
			</Disclosure>

			<IndicadoresCantidades
				data={counts}
				setFiltroStock={setFiltroStock}
			/>

			<div>
				<h1 style={{ marginBottom: 0 }}> Artículos </h1>
				<TablaArticulos
					data={filteredData}
					error={errorArticulos}
					isPending={articulosPending}
				/>
			</div>
		</div>
	);
}